import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Grid } from '@mui/system';
import { useSelector } from 'react-redux';
import { IValuationChartData } from 'dashboard409a/components';
import { IValuationState } from 'dashboard409a/states/features/valuation';
import { RootStateType } from 'dashboard409a/states/store';
import { CommonStockValueChart } from './Components/CommonStockValueChart';
import { ValuationOpinionSummaryData } from './Components/ValuationOpinionSummaryData';
import { ValuationTrendCards } from './Components/ValuationTrendCards';

const Valuation = () => {
  // Collapsed by default — the redesigned section leads with the charts;
  // the table is one click away via "Show Trends Details".
  const [showTrendsDetails, setShowTrendsDetails] = useState<boolean>(false);
  const { allValuationScalarOpinion } = useSelector<RootStateType, IValuationState>(state => state.valuation);

  const displayTable = (): void => {
    setShowTrendsDetails(!showTrendsDetails);
  };

  // Any valuation at all is enough to chart — one bar is still information.
  const componentShouldRender = (data: IValuationChartData[] | null): boolean => !!data && data.length > 0;

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2}>
        {componentShouldRender(allValuationScalarOpinion) ? (
          <>
            {/* Banner takes its own full-width row; the charts sit below. */}
            <ValuationOpinionSummaryData shareSpace={false} />
            <CommonStockValueChart />
            <ValuationTrendCards showTrendsDetails={showTrendsDetails} displayTable={displayTable} />
          </>
        ) : (
          <ValuationOpinionSummaryData shareSpace={false} />
        )}
      </Grid>
    </Box>
  );
};

export default Valuation;
